import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import EventLabel from '../../components/EventLabel/EventLabel';

export default function ConfirmDialog({ onConfirm, onCancel }: any) {
  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={onCancel}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                    <EventLabel name="AreYouSure" groupName="CMS.MatchMaking" />
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      <EventLabel name="DeclineMeetingInfo" groupName="CMS.MatchMaking" />
                    </p>
                  </div>

                  <div className="mt-4 flex gap-x-2 items-center">
                    <button type="button" className="inline-flex text-sm  justify-center rounded-md border border-transparent bg-neutral-200" onClick={onCancel}>
                      <EventLabel name="Cancel" groupName="CMS.MatchMaking" />
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center text-sm rounded-md border border-transparent bg-amber-500 text-white"
                      onClick={onConfirm}
                    >
                      <EventLabel name="Decline" groupName="CMS.MatchMaking" />
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
